<div class="box-eventos-mapa">
    <div class="box-eventos-mapa__item"><img src="/assets/img/sura-icon-frenado.svg" alt="SURA ICON FRENADO" />
        <p>Frenado brusco</p>
        <h4 id="countFrenado">{{eventosMapa.eventHardBrakeCount}}<strong>VECES</strong></h4>
    </div>
    <div class="box-eventos-mapa__item"><img src="/assets/img/sura-icon-aceleracion.svg" alt="SURA ICON ACELERACION" />
        <p>Acleración brusca</p>
        <h4 id="countFrenado">{{eventosMapa.eventHardAccelerationCount}}<strong>VECES</strong></h4>
    </div>
    <div class="box-eventos-mapa__item"><img src="/assets/img/sura-icon-velocidad.svg" alt="SURA ICON VELOCIDAD" />
        <p>Velocidad</p>
        <h4 id="countFrenado">{{eventosMapa.eventSpeedingCount}}<strong>VECES</strong></h4>
    </div>
    <div class="box-eventos-mapa__item"><img src="/assets/img/sura-icon-nocturna.svg" alt="SURA ICON NOCTURNA" />
        <p>Conducción nocturna</p>
        <h4 id="countFrenado">{{eventosMapa.eventNightTimeCount}}<strong>VECES</strong></h4>
    </div>
</div>